module.exports = __webpack_public_path__ + "img/313.541dffde.png";